class ContextualError extends Error {
  constructor(message) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super(message);
    this.name = this.constructor.name;
    this.context = context;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
export default ContextualError;